// This is an autogenerated file. Do not manually edit.
// Run `node packages/controls/mini-fluent-icons-svg/updateIcons.js` to update the icons in this package
import * as React from 'react';
import CreateSvgIcon from '../components/CreateSvgIcon';
import { registerIcons } from '@uifabric/styling/lib/utilities/icons';

const RewardsRegular = CreateSvgIcon({
    Svg: props => (
        <svg {...props} viewBox="0 0 2048 2048" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2048 640l-839 420q73 29 133 77t104 110 66 136 24 153q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-79 23-152t67-136 103-111 134-77L0 640V0h2048v640zM384 128H128v433l256 128V128zm1024 1408q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150zm128-1408H512v625l512 256 512-256V128zm384 0h-256v561l256-128V128z" />
        </svg>
    ),
    displayName: 'RewardsRegular',
});

export default 'RewardsRegular';

registerIcons({
    icons: {
        RewardsRegular: <RewardsRegular />,
    },
});
